export default __webpack_public_path__ + "static/media/Blooded Boots of the Tribes.008335fd.jpg";